import type { Component } from "vue";

import ChatAgentToolProactiveCoachingOffer from "./ChatDetail/ChatAgentToolProactiveCoachingOffer.vue";
import ChatAgentToolProactiveFeatureOffer from "./ChatDetail/ChatAgentToolProactiveFeatureOffer.vue";
import ChatEmailDraft from "./ChatDetail/ChatEmailDraft.vue";
import ChatPerformancePicker from "./ChatDetail/ChatPerformancePicker.vue";
import ChatRolePlaySetupForm from "./ChatDetail/ChatRolePlaySetupForm.vue";
import ChatViewRolePlaySummary from "./ChatDetail/ChatViewRolePlaySummary.vue";
import ReviewDocumentUploadCard from "./ChatDetail/ReviewDocumentUploadCard.vue";
import type {
    ParseActionsEmailDraftAction,
    ParseActionsGenericAction,
    ParseActionsProactiveCoachingOfferAction,
    ParseActionsProactiveFeatureOfferAction,
    ParseActionsReviewDocumentCardAction,
    ParseActionsRolePlaySetupAction,
    ParseActionsRolePlaySummaryAction,
} from "./types/chat";

export type UiDirectiveAction =
    | ParseActionsReviewDocumentCardAction
    | ParseActionsRolePlaySetupAction
    | ParseActionsRolePlaySummaryAction
    | ParseActionsProactiveCoachingOfferAction
    | ParseActionsProactiveFeatureOfferAction
    | ParseActionsEmailDraftAction
    | ParseActionsGenericAction;

export type UiDirectiveFlags = {
    proactiveCoachingOfferEnabled: boolean;
    proactiveFeatureOfferEnabled: boolean;
};

// Registry of UI directive components keyed by action name.
// All registered components must accept the same props: { data, messageId, lineIdx }.
// If directive props diverge in the future, consider typing this as a map of
// component name → expected params shape with validation at registration time.
const registry: Record<string, Component> = {
    role_play_setup: ChatRolePlaySetupForm,
    role_play_summary: ChatViewRolePlaySummary,
    pm_picker: ChatPerformancePicker,
    review_document_upload: ReviewDocumentUploadCard,
    proactive_coaching_offer: ChatAgentToolProactiveCoachingOffer,
    proactive_feature_offer: ChatAgentToolProactiveFeatureOffer,
    email_draft: ChatEmailDraft,
};

export function hasDirective(name: string): boolean {
    return name in registry;
}

export function resolveDirective(name: string, flags: UiDirectiveFlags): Component | null {
    if (name === "proactive_coaching_offer" && !flags.proactiveCoachingOfferEnabled) {
        return null;
    }
    if (name === "proactive_feature_offer" && !flags.proactiveFeatureOfferEnabled) {
        return null;
    }
    return registry[name] || null;
}
